import { ReportInput } from '@totem/components/cyberReview/parameterTypes';
import { Filter } from '@totem/types/common';

export const buildReportFilters = (input: ReportInput) => {
  const paramFilters: Filter[] = [];
  if (
    typeof input.name !== 'undefined' &&
    input.name !== null &&
    input.name.trim() !== ''
  ) {
    paramFilters.push({
      field: 'name',
      operator: 'cscontains',
      values: [input.name],
    });
  }

  if (
    typeof input.name !== 'undefined' &&
    input.name !== null &&
    input.name.trim() !== ''
  ) {
    paramFilters.push({
      field: 'email',
      operator: 'cscontains',
      values: [input.username],
    });
  }

  return paramFilters;
};

export const getRoleString = (role: number) => {
  switch (role) {
    case -1:
      return 'Vendor';
    case 0:
      return 'Collaborator';
    case 1:
      return 'Team Member';
    case 2:
      return 'Administrator';
    case 3:
      return 'System Administrator';
    default:
      return '-';
  }
};
